interface AppConfig {
    siteURL: string;
  }
  
  const configFile: AppConfig = require('./config.json');
  
  export default configFile;